import { generateId } from '@freelancer/datastore/testing/helpers';
import type { SupportCategory } from './support-categories.model';

export interface GenerateSupportCategoryOptions {
  readonly id?: number;
  readonly name?: string;
  readonly priority?: number;
}

export function generateSupportCategoryObject({
  id = generateId(),
  name,
  priority,
}: GenerateSupportCategoryOptions = {}): SupportCategory {
  return {
    id,
    name: name ?? `Category ${id}`,
    priority,
  };
}

export function generateSupportCategoryObjects(
  categories: readonly GenerateSupportCategoryOptions[],
): readonly SupportCategory[] {
  return categories.map(category => generateSupportCategoryObject(category));
}
